import React from 'react';
import {
  iconClassForNotification,
  iconShapeForNotification
} from 'vrlcm-gui-utils';
import './NotificationIcon.css';

interface Props {
  size?: number;
  name: string;
  level?: 'INFO' | 'ERROR';
}

const NotificationIcon: React.SFC<Props> = ({ size = 20, name, level }) => (
  <clr-icon
    shape={iconShapeForNotification(name, level)}
    class={'is-solid ' + iconClassForNotification(name, level)}
    size={size}
  />
);

export default NotificationIcon;
